import styled from "styled-components";

export const VolunteerHeading = styled.div`
  color: #2b3445;
  font-size: x-large;
  font-weight: 700;
  margin: 0 0 0.75rem;
`;

export const SearchAddDiv = styled.div`
  color: #2b3445;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: space-between;
  line-height: 21px;
  margin: 0px 0px 16px;
  @media print {
    display: none;
  }
`;

export const SearchContainer = styled.div`
  width: 40%;
  align-items: center;
  background-color: #ffffff;
  border-radius: 8px;
  color: #7d879c;
  display: flex;
  font-weight: 500;
  padding: 2px 16px;
  border: 1px solid #4187e8;
`;
export const ReportSearchContainer = styled.div`
  width: 100%;
  align-items: center;
  background-color: #ffffff;
  border-radius: 8px;
  color: #7d879c;
  display: flex;
  font-weight: 500;
  padding-top: 0;
  border: 1px solid #4187e8;
  @media print {
    display: none;
  }
`;

export const SearchBox = styled.input`
  color: #7d879c;
  font-size: 16px;
  font-weight: 500;
  width: 90%;
  padding: 4px 0px 5px;
  border: none;
  outline: none;
`;

export const SearchIconDiv = styled.div`
  color: #7d879c;
  fill: #7d879c;
  margin: 0px 3px 0px 0px;
  padding-top: 2px;
`;

export const HeaderDiv = styled.span`
  align-items: center;
  color: #2b3445;
  display: inline-flex;
  font-size: 14px;
  font-weight: 600;
  justify-content: flex-start;
  line-height: 24px;
  text-align: left;
`;

export const InputFieldDiv = styled.div`
  margin-right: 1.5rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: 1fr;
  }
`;

export const InputDiv = styled.div`
  color: #2b3445;
  flex-basis: 50%;
  font-size: 14px;
  line-height: 21px;
  padding: 24px 0px 0px 24px;
`;
export const InputDiv1 = styled.div`
  color: #2b3445;
  flex-basis: 50%;
  font-size: 14px;
  line-height: 21px;
  padding: 24px 0px 0px 0px;
`;

export const ErrorMessage = styled.p`
  color: rgb(233, 69, 96);
  font-weight: 400;
  font-size: 0.75rem;
  text-align: left;
  margin: 2px 14px 0px;
`;

export const PaginationDiv = styled.span`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* margin: 1rem 0px; */
  padding: 0.1rem 2rem;
  /* width: 100%; */
  @media print {
    display: none;
  }
`;
export const RegHeadingDiv = styled.div`
  /* border-color: #2c5282; */
  /* border-style: solid; */
  /* border-width: 1px; */
  color: #ffffff;
  display: flex;
  flex-wrap: wrap;
  line-height: 24px;
  margin: 32px 64px 0px;
`;
export const RegHeading = styled.div`
  align-items: center;
  color: #000000;
  display: flex;
  justify-content: center;
  line-height: 24px;
  padding: 16px;
  text-align: center;
`;
export const RegHeading1 = styled.div`
  align-items: center;
  color: #000000;
  display: flex;
  justify-content: center;
  line-height: 24px;
  padding: 16px;
  text-align: center;
`;
export const RegValue = styled.div`
  align-items: center;
  color: #000000;
  display: flex;
  justify-content: center;
  line-height: 24px;
  padding: 16px;
  text-align: center;
`;

export const ImageDiv = styled.div`
  align-items: center;
  background-color: #f6f9fc;
  border-color: #e3e9ef;
  border-radius: 10px;
  border-style: dashed;
  border-width: 1.5px;
  color: #2b3445;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem 1rem;
  text-align: center;
  gap: 0.75rem;
`;

export const ImageDivText = styled.div`
  color: #7d879c;
  font-weight: 600;
  text-align: center;
`;
export const InputContainer = styled.div`
  /* display: flex;
  text-overflow: clip; */
  /* flex-direction: row-reverse; */
  display: grid;
  grid-template-columns: 1fr 1fr;
  /* width: 100%; */
  height: 2.5rem;
`;
export const Input = styled.input`
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  transition-duration: 300ms;
  width: 100%;
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;
  border-width: 1px;
`;
export const PidDiv = styled.div`
  border: 1px solid black;
  padding: 0.4rem 0.5rem;
  /* padding-right: 0.5rem; */
  transition-duration: 300ms;
  width: 100%;
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;
  border-width: 1px;
  color: black;
  letter-spacing: 0.5rem;
  font-size: x-large;
  font-weight: 800;
`;
export const RegisterDiv = styled.div`
  border: 1px solid black;
  padding: 0.4rem 0.5rem;
  /* padding-right: 0.5rem; */
  transition-duration: 300ms;
  width: 100%;
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;
  border-width: 1px;
  color: black;
  letter-spacing: 0.2rem;
  font-size: normal;
  font-weight: 600;
`;
export const InputLevel = styled.label`
  align-items: center;
  /* background-color: #22c55e; */
  background-color: #6366f1;
  border-color: #6366f1;
  border-radius: 8px 0px 0px 8px;
  border-style: solid;
  border-width: 1px;
  color: #ffffff;
  display: flex;
  font-family: "Poppins";
  /* font-family: ui-sans-serif; */
  font-size: normal;
  font-weight: 600;
  /* line-height: 20px; */
  padding: 0px 8px;
`;

export const HorizontalRule = styled.hr`
  display: block;
  margin: auto;
  width: 100%;
  height: 0.1rem;
  border-radius: 0.8rem;
  border: none;
  background: linear-gradient(to right, #cfcfcf 0%, #cfcfcf 79%);
  background-color: #ebd0d0;
  margin: 1rem 0;
  /* background: linear-gradient(to right, #14163c 0%, #03217b 79%);
  background-color: #ebd0d0; */
`;
export const MouseDiv = styled.div`
  &:hover {
    color: red;
  }
`;
export const HistoryTable = styled.table`
  width: 100%;
  /* overflow: hidden; */
  background-color: #ffffff;
  border-radius: 0.5rem;
  /* margin-top: 1.25rem; */
  margin-bottom: 1.25rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  /* border-spacing: 0;
  border-width: 0;
  padding: 0;
  border-width: 0; */
  border: 1px solid #ddd;
  text-align: left;
  border-collapse: collapse;
`;
export const TableHeadTr = styled.tr`
  display: table-row;
  border-radius: 0;
  margin-bottom: 0;

  /* border: "none"; */
`;
export const TableHeadTh = styled.th`
  padding: 0.5rem;
  text-align: left;
  background-color: #41baaf;

  /* background-color: ${(props) => props.theme.color.secondary}; */
  /* border: "none"; */
`;
export const TableBodyTd = styled.td`
  /* border: 1px solid #d3d3d3; */
  border: 1px solid #ddd;
  text-align: left;
  /* padding: 0.75rem; */
  &:hover {
    /* background-color: #f3f4f6; */
  }
`;
export const TableBodyDelete = styled.td`
  border: 1px solid #d3d3d3;
  padding: 0.5rem;
  color: #f87171;
  cursor: pointer;
  &:hover {
    background-color: #f3f4f6;
    color: #dc2626;
    font-weight: 500;
  }
`;
export const TableInput = styled.input`
  /* width: 1px; */
  border-spacing: 0;
  /* border: 1px solid #d3d3d3; */
  border: none;
  padding: 0.8rem;
  &:focus {
    outline: none;
    border: none;
  }
`;
